import { extends as _extends, objectSpread2 as _objectSpread2 } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { BackButton } from '../BackButton.js';
import { Button } from '../Button/index.js';
import { useContainerProps } from '../../hooks/useContainerProps.js';
import { renderContainerChildren } from '../../utils/RenderUtil.js';
import { reactifiPageTitle } from '../../metatags/title.js';
import Dropdown from 'react-bootstrap/Dropdown';
import classNames from 'classnames';
import { FAIcon } from '../fa-icon/component.js';
import { formatClassName as _formatClassName } from '../../utils/formatClassName.js';
/** renders a div that is styled to fill the header area */

var Header = function Header(props) {
  props = useContainerProps(props);
  var _props = props,
      back = _props.back,
      button = _props.button,
      className = _props.className,
      data = _props.data,
      headerTabs = _props.headerTabs,
      icon = _props.icon,
      iconProps = _props.iconProps,
      noBorder = _props.noBorder,
      noPadding = _props.noPadding,
      noBackground = _props.noBackground,
      router = _props.router,
      subTitleSection = _props.subTitleSection,
      title = _props.title,
      WrapperComponent = _props.WrapperComponent,
      additionalTitleDisplay = _props.additionalTitleDisplay,
      hasNotifications = _props.hasNotifications,
      isSticky = _props.isSticky;

  function renderTitleBar() {
    if (!back && !icon && !title && !button) {
      return null;
    }

    if (WrapperComponent) {
      return /*#__PURE__*/React.createElement(WrapperComponent, null, /*#__PURE__*/React.createElement("div", {
        className: "header-titlebar",
        style: {
          padding: 0
        }
      }, renderTitleBarInner()));
    } else {
      return /*#__PURE__*/React.createElement("div", {
        className: _formatClassName(['header-titlebar', {
          'no-background': noBackground,
          'header-tabs': headerTabs
        }])
      }, renderTitleBarInner());
    }
  }

  function renderTitleBarInner() {
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
      className: "header-titlebar-left"
    }, /*#__PURE__*/React.createElement("h1", _extends({
      className: "header-titlebar-title"
    }, getDataProps(data)), back && /*#__PURE__*/React.createElement(BackButton, {
      action: back,
      router: router,
      "data-back-arrow": true
    }), icon && typeof icon === 'string' ? /*#__PURE__*/React.createElement(FAIcon, _extends({
      icon: icon
    }, iconProps, {
      additionalClasses: "header-titlebar-icon"
    })) : icon, title, additionalTitleDisplay && /*#__PURE__*/React.createElement("span", {
      className: "ps-2"
    }, additionalTitleDisplay))), /*#__PURE__*/React.createElement("div", {
      className: "header-titlebar-right"
    }, renderButtons()));
  }

  function renderButtons() {
    if (Array.isArray(button)) {
      return button.map(renderButton);
    } else if (button && button.action) {
      return renderButton(button);
    } else {
      return button;
    }
  }
  /* eslint-disable-next-line react/no-multi-comp */


  function renderButton(button, index) {
    var _button2;

    var _button = button,
        icon = _button.icon,
        rightIcon = _button.rightIcon,
        label = _button.label,
        action = _button.action;

    if (!icon && !label) {
      return null;
    }

    button = _objectSpread2(_objectSpread2({}, button), {}, {
      className: classNames('ui-default', (_button2 = button) === null || _button2 === void 0 ? void 0 : _button2.className)
    });
    var hasMultipleActions = Array.isArray(action) && action.length > 1;
    var handler = Array.isArray(action) && action.length === 1 ? action[0].action : action;
    return hasMultipleActions ? /*#__PURE__*/React.createElement(Dropdown, {
      "data-type": "dropdown",
      key: index
    }, /*#__PURE__*/React.createElement(Dropdown.Toggle, _extends({
      className: "ui-default btn btn-".concat(button.style)
    }, getDataProps(button.data)), icon && /*#__PURE__*/React.createElement(FAIcon, {
      icon: icon,
      additionalClasses: "left"
    }), label, rightIcon && /*#__PURE__*/React.createElement(FAIcon, {
      icon: rightIcon,
      additionalClasses: "right"
    })), /*#__PURE__*/React.createElement(Dropdown.Menu, null, button.action.map(function (item, idx) {
      return /*#__PURE__*/React.createElement(Dropdown.Item, _extends({
        key: idx,
        onClick: item.action
      }, getDataProps(item.data)), item.label);
    }))) : /*#__PURE__*/React.createElement(Button, _extends({
      key: index
    }, button, {
      onClick: handler
    }));
  }

  function getDataProps() {
    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var dataProps = {};

    if (data.action) {
      dataProps['data-action'] = data.action;
    }

    if (data.objectId) {
      dataProps['data-object-id'] = data.objectId;
    }

    if (data.objectType) {
      dataProps['data-object-type'] = data.objectType;
    }

    return dataProps;
  }

  useEffect(function () {
    if (title) {
      reactifiPageTitle(title);
    }
  }, [title]);
  return /*#__PURE__*/React.createElement("div", {
    className: _formatClassName(['header', className, {
      'no-border': noBorder,
      'no-padding': noPadding,
      'no-background': noBackground,
      'header-sticky': isSticky
    }])
  }, renderTitleBar(), subTitleSection && subTitleSection, hasNotifications && headerTabs, renderContainerChildren(props, null, WrapperComponent), !hasNotifications && headerTabs);
};

Header.displayName = "Header";
Header.defaultProps = {
  isSticky: true
};
Header.propTypes = {
  additionalTitleDisplay: PropTypes.node,
  back: PropTypes.oneOfType([PropTypes.bool, PropTypes.func]),
  button: PropTypes.oneOfType([PropTypes.shape(Button.propTypes), PropTypes.arrayOf(PropTypes.shape(Button.propTypes))]),
  children: PropTypes.node,
  className: PropTypes.string,
  data: PropTypes.object,
  subTitleSection: PropTypes.node,
  headerTabs: PropTypes.node,
  icon: PropTypes.string,
  iconProps: PropTypes.object,
  noBackground: PropTypes.bool,
  noBorder: PropTypes.bool,
  noPadding: PropTypes.bool,
  router: PropTypes.shape({
    goBack: PropTypes.func
  }),
  title: PropTypes.string,
  WrapperComponent: PropTypes.elementType,
  hasNotifications: PropTypes.bool,
  isSticky: PropTypes.bool
};
export { Header };